import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { FaUserCircle } from "react-icons/fa";
import { MdOutlineFemale } from "react-icons/md";

const testimonials = [
  {
    id: 1,
    name: "Ananya Sharma",
    city: "Delhi",
    age: 27,
    description:
      "I have been struggling with PCOS for the past 5 years and have tried multiple treatment options but nothing could near the PCOS reversal program of Glow PCOD. For the first time I could see positive changes in my symptoms. Thanks to Glow PCOD for this.",
  },
  {
    id: 2,
    name: "Megha Verma",
    city: "Bengaluru",
    age: 25,
    description:
      "I was in a poor mental state and going through both PCOS & Depression, unwittingly. But Glow PCOD diagnosed me with such agility and efficiency that it enrolled me in the right recovery plan with the wonderful set of PCOS specialists. Thank you Glow PCOD!",
  },
  {
    id: 3,
    name: "Priya Nair",
    city: "Mumbai",
    age: 30,
    description:
      "My experience with Glow PCOD was so awesome and comfortable. The whole team is so empathetic and caring. My care manager was genuinely invested in my PCOS recovery journey and patiently motivated me during my downtimes.",
  },
  {
    id: 4,
    name: "Ritika Singh",
    city: "Kolkata",
    age: 28,
    description:
      "The personalized attention and follow-up care were remarkable. This hospital truly sets the standard for medical excellence and patient care.",
  },
  {
    id: 5,
    name: "Neha Gupta",
    city: "Hyderabad",
    age: 26,
    description:
      "Glow PCOD changed my life completely. With their structured plan and supportive team, I was able to manage my PCOS naturally and improve my overall health significantly.",
  },
  {
    id: 6,
    name: "Sneha Patel",
    city: "Ahmedabad",
    age: 29,
    description:
      "The team at Glow PCOD is wonderful! They guided me throughout and helped me achieve a healthier lifestyle while managing my PCOS.",
  },
];

const Testimonial = () => {
  const [index, setIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [visibleCount, setVisibleCount] = useState(1);

  const totalPages = Math.ceil(testimonials.length / visibleCount);

  useEffect(() => {
    const updateCount = () => {
      if (window.innerWidth >= 1024) {
        setVisibleCount(3);
      } else if (window.innerWidth >= 768) {
        setVisibleCount(2);
      } else {
        setVisibleCount(1);
      }
    };

    updateCount();
    window.addEventListener("resize", updateCount);
    return () => window.removeEventListener("resize", updateCount);
  }, []);

  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + visibleCount) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [isPaused, visibleCount]);

  const visibleTestimonials = Array.from({ length: visibleCount }, (_, i) => {
    return testimonials[(index + i) % testimonials.length];
  });

  return (
    <div className="overflow-hidden w-full py-20">
      <motion.h1
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.2 }}
        transition={{ duration: 0.6 }}
        className="text-pink-600 text-3xl md:text-5xl font-bold text-center my-16"
      >
        Hear it from our patients themselves
      </motion.h1>

      <div
        className="relative w-full flex items-center justify-center"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="w-full max-w-6xl flex gap-6">
          <AnimatePresence mode="wait">
            {visibleTestimonials.map((t) => (
              <motion.div
                key={t.id}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.6 }}
                whileHover={{ scale: 1.05, transition: { duration: 0.1 } }}
                className="flex-1 bg-white shadow-lg rounded-2xl p-8"
              >
                <div className="flex items-center gap-3 mb-4">
                  <FaUserCircle className="text-pink-500 text-4xl" />
                  <div>
                    <h4 className="font-semibold text-pink-600 text-lg">
                      {t.name.split(" ")[0]}
                    </h4>
                    <p className="text-sm text-gray-500 flex items-center">
                      <MdOutlineFemale className="text-pink-700" size={20} />
                      {t.age} yrs • {t.city}
                    </p>
                  </div>
                </div>

                <p className="text-gray-700 text-base italic leading-relaxed">
                  “{t.description}”
                </p>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>

      <div className="flex justify-center gap-2 mt-8">
        {Array.from({ length: totalPages }).map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i * visibleCount)}
            className={`h-2 w-2 rounded-full transition-all cursor-pointer ${
              Math.floor(index / visibleCount) === i
                ? "bg-pink-600 w-4"
                : "bg-gray-400"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonial;
